import { registerComponent } from '@gig/magic-common';
import MultipleAnswerComponent from './multiple-answer.vue.js';

var MultipleAnswer = registerComponent(MultipleAnswerComponent);

export { MultipleAnswer };
